import { createFileRoute } from "@tanstack/react-router";
import { TenantWebSearchSettings } from "@client/components/tenant-settings/tenant-web-search-settings";

export const Route = createFileRoute("/_app/tenant-settings/data-sources")({
  component: TenantWebSearchSettings,
});
